/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_To_Play_How_Body_1Inputs */

const bn_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`একটি দৈনিক চ্যালেঞ্জ বা কাস্টম রান শুরু করুন, হাইলাইট করা এলাকা অধ্যয়ন করুন, আপনার অনুমান টাইপ করুন এবং পরবর্তী রাউন্ডে যাওয়ার আগে এটি জমা দিন।`)
};

const de_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starten Sie eine tägliche Herausforderung oder einen benutzerdefinierten Lauf, studieren Sie den hervorgehobenen Bereich, geben Sie Ihre Schätzung ein und senden Sie sie ab, bevor Sie mit der nächsten Runde fortfahren.`)
};

const el_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ξεκινήστε μια καθημερινή πρόκληση ή προσαρμοσμένο τρέξιμο, μελετήστε την επισημασμένη περιοχή, πληκτρολογήστε την εικασία σας και υποβάλετέ την πριν προχωρήσετε στον επόμενο γύρο.`)
};

const en_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a daily challenge or custom run, study the highlighted area, type your guess, and submit it before moving to the next round.`)
};

const es_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicie un desafío diario o una carrera personalizada, estudie el área resaltada, escriba su suposición y envíela antes de pasar a la siguiente ronda.`)
};

const fr_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancez un défi quotidien ou une partie personnalisée, observez la zone surlignée, saisissez votre réponse puis validez avant de passer à la manche suivante.`)
};

const hi_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक दैनिक चुनौती या कस्टम दौड़ शुरू करें, हाइलाइट किए गए क्षेत्र का अध्ययन करें, अपना अनुमान टाइप करें और अगले दौर में जाने से पहले इसे सबमिट करें।`)
};

const hu_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indítson el egy napi kihívást vagy egyéni futást, tanulmányozza a kiemelt területet, írja be a tippjét, és küldje el, mielőtt a következő fordulóba lépne.`)
};

const id_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai tantangan harian atau lari khusus, pelajari area yang disorot, ketik tebakan Anda, dan kirimkan sebelum melanjutkan ke babak berikutnya.`)
};

const it_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvia una sfida quotidiana o una corsa personalizzata, studia l'area evidenziata, digita la tua ipotesi e inviala prima di passare al turno successivo.`)
};

const ja_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎日のチャレンジまたはカスタム ランを開始し、強調表示されている領域を研究し、推測を入力して、次のラウンドに進む前に送信します。`)
};

const ko_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일일 챌린지 또는 맞춤형 달리기를 시작하고, 강조 표시된 영역을 연구하고, 추측을 입력하고, 다음 라운드로 이동하기 전에 제출하세요.`)
};

const nl_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start een dagelijkse uitdaging of een aangepaste run, bestudeer het gemarkeerde gebied, typ uw gok en dien deze in voordat u doorgaat naar de volgende ronde.`)
};

const pl_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij codzienne wyzwanie lub niestandardowy bieg, przestudiuj podświetlony obszar, wpisz swoją odpowiedź i prześlij ją przed przejściem do następnej rundy.`)
};

const pt_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicie um desafio diário ou corrida personalizada, estude a área destacada, digite seu palpite e envie-o antes de passar para a próxima rodada.`)
};

const ru_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начните ежедневное задание или индивидуальный забег, изучите выделенную область, введите свое предположение и отправьте его, прежде чем переходить к следующему раунду.`)
};

const sv_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starta en daglig utmaning eller anpassad löpning, studera det markerade området, skriv din gissning och skicka in den innan du går vidare till nästa omgång.`)
};

const tr_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günlük bir mücadeleye veya özel koşuya başlayın, vurgulanan alanı inceleyin, tahmininizi yazın ve bir sonraki tura geçmeden önce gönderin.`)
};

const uk_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розпочніть щоденне завдання або індивідуальний забіг, вивчіть виділену область, введіть своє припущення та надішліть його, перш ніж переходити до наступного раунду.`)
};

const vi_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu thử thách hàng ngày hoặc cuộc chạy tùy chỉnh, nghiên cứu khu vực được đánh dấu, nhập dự đoán của bạn và gửi dự đoán trước khi chuyển sang vòng tiếp theo.`)
};

const zh_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始每日挑战或自定义跑步，研究突出显示的区域，输入您的猜测，然后在进入下一轮之前提交。`)
};

const zh_hant_how_to_play_how_body_1 = /** @type {(inputs: How_To_Play_How_Body_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始每日挑戰或自訂跑步，研究突出顯示的區域，輸入您的猜測，然後在進入下一輪之前提交。`)
};

/**
* | output |
* | --- |
* | "Start a daily challenge or custom run, study the highlighted area, type your guess, and submit it before moving to the next round." |
*
* @param {How_To_Play_How_Body_1Inputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const how_to_play_how_body_1 = /** @type {((inputs?: How_To_Play_How_Body_1Inputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_To_Play_How_Body_1Inputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_how_to_play_how_body_1(inputs)
	if (locale === "de") return de_how_to_play_how_body_1(inputs)
	if (locale === "el") return el_how_to_play_how_body_1(inputs)
	if (locale === "en") return en_how_to_play_how_body_1(inputs)
	if (locale === "es") return es_how_to_play_how_body_1(inputs)
	if (locale === "fr") return fr_how_to_play_how_body_1(inputs)
	if (locale === "hi") return hi_how_to_play_how_body_1(inputs)
	if (locale === "hu") return hu_how_to_play_how_body_1(inputs)
	if (locale === "id") return id_how_to_play_how_body_1(inputs)
	if (locale === "it") return it_how_to_play_how_body_1(inputs)
	if (locale === "ja") return ja_how_to_play_how_body_1(inputs)
	if (locale === "ko") return ko_how_to_play_how_body_1(inputs)
	if (locale === "nl") return nl_how_to_play_how_body_1(inputs)
	if (locale === "pl") return pl_how_to_play_how_body_1(inputs)
	if (locale === "pt") return pt_how_to_play_how_body_1(inputs)
	if (locale === "ru") return ru_how_to_play_how_body_1(inputs)
	if (locale === "sv") return sv_how_to_play_how_body_1(inputs)
	if (locale === "tr") return tr_how_to_play_how_body_1(inputs)
	if (locale === "uk") return uk_how_to_play_how_body_1(inputs)
	if (locale === "vi") return vi_how_to_play_how_body_1(inputs)
	if (locale === "zh") return zh_how_to_play_how_body_1(inputs)
	return zh_hant_how_to_play_how_body_1(inputs)
});